import React, { useEffect, useState } from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import { useIntl, getLocale } from 'umi';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

interface ColumnType {
  key: string;
  title: string;
  // dataSource: DataSourceMetricType | 'ogdb'; //'appannie' | 'sensortower' | 'ogdb';
  currentSortKey: string;
  currentSortValue: '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: string;
  isNoDropdown?: boolean;
  width: number;
  width_cn?: number;
  getMetricValueOfCvm: (cvm: any, metricKey: string) => string;
  metricKey?: string;
  entityType?: string;
}

export const RPDMetricColumn = (params: ColumnType, dataSource = 'appannie') => {
  const {
    key,
    title,
    sortMetric,
    currentSortKey,
    currentSortValue,
    textContent,
    onSortChage,
    getMetricValueOfCvm = () => console.log,
    width,
    width_cn,
    isNoDropdown,
    metricKey,
    entityType = '',
  } = params;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const localeWidth = locale === LANGUAGE_CN ? width_cn || width : width;

  return {
    key,
    width: localeWidth,
    align: 'center',
    header: (
      <CloumsCenter width={localeWidth} align={'right'}>
        <SortBy
          title={title}
          defaultKey={currentSortKey}
          defaultValue={currentSortValue}
          svgIcon={dataSource === 'appannie' ? AppAnnie : SensorTower}
          isNoDropdown={isNoDropdown}
          list={[
            {
              key,
              sortMetric,
              // orderSource: dataSource,
              text: title,
              title,
              ratioType: 0,
            },
          ]}
          onChange={onSortChage}
          svgTip={
            <DataSourceBubbleInfo
              dataOfDom={title}
              metricKey={metricKey}
              entityType={entityType}
              comesFormDom={
                <>
                  <img src={getDataSourceIcon(dataSource)} />
                  {DATASOURCE_NAME[dataSource]}
                </>
              }
              dataSource={dataSource}
            />
          }
          content={
            <>
              {formatMessage({ id: textContent })}
              <br />
              {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
            </>
          }
        />
      </CloumsCenter>
    ),
    render: (cvm: any) => {
      const value = getMetricValueOfCvm(cvm, key);
      return (
        <CloumsCenter width={localeWidth} align="right">
          <div className="table-row">
            <span className="table-row-title">{value}</span>
          </div>
        </CloumsCenter>
      );
    },
  };
};
